import { Grid, Box, Typography, Divider, FormControl, Select, MenuItem, TextField, SelectChangeEvent, Stack } from '@mui/material'
import { formatNumber } from 'store/utils'

import ExpandOutlinedIcon from '@mui/icons-material/ExpandOutlined'
import SectionContainer from 'containers/dashboard/components/SectionContainer'
import { GAP_DETAILS } from './gapTexts'
import { getGapCategory } from '../gapThresholds'

type Props = { gap: number; topCompaniesNumber: number; onChangeTopCompaniesNumber: (x: number) => void }

export default function CompetitiveStrengthGap({ gap, topCompaniesNumber, onChangeTopCompaniesNumber }: Props) {
  const category = getGapCategory(gap)
  const gapDetails = GAP_DETAILS[category]
  const gapTitleColor = gapDetails.color
  const greyColor = 'normalGrey.main'
  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 6, md: 12 }}>
      <Grid size={{ xs: 4, md: 6 }}>
        <SectionContainer>
          <Box p={3} display={'flex'} alignItems="center">
            <Box
              sx={{
                borderRadius: '50%',
                boxShadow: '0 0 10px rgba(156, 156, 156, 0.3)', // sombra grisácea
                p: 2,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              <ExpandOutlinedIcon fontSize="large" />
            </Box>
            <Box pl={5} color={greyColor}>
              <Typography pb={1.4} fontSize={15}>
                Competitive Strength Gap
              </Typography>
              <Typography color={gapTitleColor} fontSize={36}>
                {gap > 0 && <>+</>}
                {formatNumber(gap)}%{' '}
                <Typography pl={3} component="span" sx={{ display: 'inline' }}>
                  {gapDetails.category}
                </Typography>
              </Typography>
            </Box>
          </Box>
          <Divider />
          <Box display={'flex'} p={2} color={greyColor} alignItems="center" fontSize={12} justifyContent={'center'}>
            Compared against the
            <FormControl size="small" sx={{ px: 1 }}>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={topCompaniesNumber.toString()}
                onChange={(event: SelectChangeEvent) => {
                  onChangeTopCompaniesNumber(Number(event.target.value))
                }}
                sx={{ color: 'primary.main' }}>
                <MenuItem value={'10'}>Top 10</MenuItem>
                <MenuItem value={'30'}>Top 30</MenuItem>
                <MenuItem value={'70'}>Top 70</MenuItem>
              </Select>
            </FormControl>
            competitors
          </Box>
        </SectionContainer>
      </Grid>
      <Grid size={{ xs: 4, md: 6 }}>
        <Box pl={3} pt={3} color={greyColor}>
          <Typography pb={1} color="primary.main" fontSize={15}>
            {gapDetails.title}
          </Typography>
          <Typography fontSize={15} sx={{ whiteSpace: 'pre-line' }}>
            {gapDetails.description}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  )
}
